import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../core';
import { Pais } from '../pais';

@Injectable({
    providedIn: 'root'
})
export class PaisTypeaheadHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApiTypeahead()}/pais`
    }

    /** Pesquisa todas as Paiss cadastradas */
    search(nomeCodigoIbge: string, limit: number): Observable<Pais[]> {
        // Params
        let params = new HttpParams();
        // Nome e código IBGE
        params = params.append('nomeCodigoIbge', nomeCodigoIbge);
        // Limit
        params = params.append('limit', limit ? limit.toString() :  null);

        return this.customHttp.get(this.pathApi, {params});
    }
}
